import React from "react";

const JobDetailsSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Job Header Skeleton */}
      <div className="flex items-start gap-4 pb-5 border-b border-slate-200">
        {/* Company Logo Skeleton */}
        <div className="flex-shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-lg bg-slate-200"></div>
        
        <div className="flex-grow space-y-2">
          {/* Title Skeleton */}
          <div className="h-7 md:h-8 bg-slate-200 rounded w-3/4"></div>
          {/* Company Name Skeleton */}
          <div className="h-5 bg-slate-200 rounded w-1/2"></div>
          {/* Description Skeleton */}
          <div className="h-4 bg-slate-200 rounded w-full"></div>
          <div className="h-4 bg-slate-200 rounded w-5/6"></div>
        </div>
      </div>

      {/* Job Info Skeleton */}
      <div className="space-y-3 py-5 border-b border-slate-200">
        {/* Section Title */}
        <div className="h-6 bg-slate-200 rounded w-40 mb-3"></div>
        
        {/* Info Items */}
        {[1, 2, 3, 4, 5].map((item) => (
          <div key={item} className="flex items-start gap-3">
            <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-slate-200"></div>
            <div className="flex-grow pt-1">
              <div className="h-5 bg-slate-200 rounded w-full max-w-md"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Action Buttons Skeleton */}
      <div className="flex items-center gap-2 py-5 border-b border-slate-200 flex-wrap">
        <div className="h-11 bg-slate-200 rounded-lg w-32"></div>
        <div className="h-11 bg-slate-200 rounded-lg w-32"></div>
        <div className="h-11 bg-slate-200 rounded-lg w-24"></div>
      </div>

      {/* Job Description Skeleton */}
      <div className="py-5">
        {/* Section Title */}
        <div className="h-6 bg-slate-200 rounded w-48 mb-4"></div>
        
        {/* Description Lines */}
        <div className="space-y-2">
          <div className="h-4 bg-slate-200 rounded w-full"></div>
          <div className="h-4 bg-slate-200 rounded w-full"></div>
          <div className="h-4 bg-slate-200 rounded w-5/6"></div>
          <div className="h-4 bg-slate-200 rounded w-full"></div>
          <div className="h-4 bg-slate-200 rounded w-4/5"></div>
          <div className="h-4 bg-slate-200 rounded w-full"></div>
          <div className="h-4 bg-slate-200 rounded w-3/4"></div>
        </div>
        
        <div className="mt-4 space-y-2">
          <div className="h-4 bg-slate-200 rounded w-full"></div>
          <div className="h-4 bg-slate-200 rounded w-5/6"></div>
          <div className="h-4 bg-slate-200 rounded w-full"></div>
          <div className="h-4 bg-slate-200 rounded w-2/3"></div>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsSkeleton;